<script setup>
import {ref} from "vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";

const {viewTypes} = defineProps(['viewTypes']);
const emit = defineEmits(["apply"]);

const showModal = ref(false);
const viewType = ref(viewTypes[1]);

function apply() {
    showModal.value = false;
    emit('apply', viewType.value.value);
}

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <ul class="filters__list__choose" style="max-height: 300px; overflow-y: auto;">
            <li v-for="item in viewTypes" :key="item.label">
                <div class="input-radio">
                    <input :id="`filter-company-${item.label}`" type="radio" v-model="viewType" :value="item">
                    <label :for="`filter-company-${item.label}`">{{item.label}}</label>
                </div>
            </li>
        </ul>

        <div class="text-center mt-2">
            <PrimaryButton
                caption="Apply"
                @click="apply"
            />
        </div>
    </div>
</template>

<style scoped>

</style>
